import React, {
	Component
} from 'react';
import { store } from '../stores/mainStore';
import styled from 'styled-components';

const Avatar = styled.div`
	display: block;
	background: rgb(34,50,117);
	background: radial-gradient(circle, rgba(88,132,194,1) 0%, rgba(34,50,117,1) 68%);
	background-size: cover;
	background-position: 50% 50%;
	position: relative;
	/* border: 4px ridge gold; */
	border-radius: 50%;
	height: 100%;
	width: 100%;
	box-sizing: border-box;

`

const CircleBody = styled.div`
	flex-grow: 0;
	box-sizing: border-box;
	position: relative;
	& > .star {

	}
`

const Ring = styled.img`
	position: absolute;
	top: 0;
	left: 0;
`

const Challenger = styled.img`
	position: absolute;
	top: 0;
	left: 0;
`

const LevelStar = styled.div`
	position: absolute;
	bottom: 0;
	right: -2vw;
	background-image: url("/assets/profile/profile_star.png");
	background-size: cover;
	height: 9vw;
	width: 9vw;
	font-size: 5vw;
	line-height: 1em;
	padding-top: 1vw;
	box-sizing: border-box;
	color: white;
	display: flex;
	justify-content: center;
	align-items: center;
	text-align: center;
	text-shadow: 2px 2px 2px rgba(0,0,0,1);
`


export class CircleAvatar extends Component {
	render(){
		var avatarStyle = {
			top: `${this.props.vw * 0.015}vw`, left: `${this.props.vw * 0.015}vw`,
			height: `${this.props.vw * 0.95}vw`, width: `${this.props.vw * 0.95}vw`,
		};
		var challengeStyle = {
			top: `-${this.props.vw * 0.125}vw`, left: `-${this.props.vw * 0.19}vw`,
			width: `${this.props.vw * 1.35}vw`,
		};
		if(this.props.isUnknown){
			avatarStyle.backgroundImage = `url('/assets/profile/portrait_unknown.jpg')`;
		} else {
			if(this.props.img){
				avatarStyle.backgroundImage = `url('${this.props.img}')`;
			} else {
				avatarStyle.backgroundImage = `url('/assets/profile/profile_default.jpg')`;
			}
		}
		const circleSize = {height: `${this.props.vw}vw`, width: `${this.props.vw}vw`}
		return(
			<CircleBody style={circleSize}>
				<Avatar style={avatarStyle}/>
				<Ring src="/assets/portrait_ring.png" style={circleSize}/>
				{this.props.challenger && <Challenger src={`/assets/languages/${store.settings.language}/circle_banner_challenge.png`} style={challengeStyle}/>}
				{this.props.nudged && <Challenger src={`/assets/languages/${store.settings.language}/circle_banner_nudge.png`} style={challengeStyle}/>}
				{!!this.props.level && <LevelStar>
					{this.props.level}
				</LevelStar>}
				{this.props.children}
			</CircleBody>
		)
	}
}
